import IMAGES from "utils/constants/image";

export const TRACKING_MODE = "TRACKING_MODE";
export const USER_ACTIONS_DASHBOARD_FIRST = "USER_ACTIONS_DASHBOARD_FIRST";
export const ONBOARDING_QUIZ = "ONBOARDING_QUIZ";
export const LINK_BUILDER_ONBOARDING = "LINK_BUILDER_ONBOARDING";
export const PAGE_BUILDER_ONBOARDING = "PAGE_BUILDER_ONBOARDING";
export const PAGE_BUILDER_FEATURE_GROUPS_ONBOARDING =
  "PAGE_BUILDER_FEATURE_GROUPS_ONBOARDING";
export const CAMPAIGN_BUILDER_AUDIENCE_ONBOARDING =
  "CAMPAIGN_BUILDER_AUDIENCE_ONBOARDING";
export const EDITOR_FIRST_TIME = "EDITOR_FIRST_TIME";

const EDUCATION_SLIDES = {
  [USER_ACTIONS_DASHBOARD_FIRST]: [
    {
      image: IMAGES.LINK_USE_CASE_EMAIL,
      title: "Sell in any channel",
      header: "PriceBlocs payment links help you sell directly through email."
    },
    {
      image: IMAGES.LINK_USE_CASE_SOCIAL,
      title: "Monetize social",
      header: "Use payment links directly with your customers over chat."
    },
    {
      image: IMAGES.LINK_USE_CASE_VIDEO,
      title: "Remote revenue",
      header:
        "Sell more easily over webinars with direct to checkout payment links."
    },
    {
      image: IMAGES.LINK_USE_CASE_SMS,
      title: "Maximise engagement",
      header: "Payment links can help you make the most of high SMS engagement."
    },
    {
      image: IMAGES.LINK_USE_CASE_CONTACTLESS,
      title: "Seamless in person payments",
      header: "Go contactless, to make selling in person, easy."
    }
  ],
  [TRACKING_MODE]: [
    {
      title: "Filter your event data",
      header:
        "To get a clearer picture of your analytics, you can choose to filter by test or live event data.",
      subheader:
        "Events captured when testing checkout within your editor or preview are registered as test events. This helps ensure your live analytics are not inflated with test checkout events."
    }
  ],
  [LINK_BUILDER_ONBOARDING]: [
    {
      image: IMAGES.PAYMENT_LINK_BUILD,
      title: "Build a payment link",
      header:
        "Choose products, prices, discounts and more, to add to your payment link."
    },
    {
      image: IMAGES.PAYMENT_LINK_OMNICHANNEL,
      title: "Omnichannel",
      header:
        "Payment links work everywhere your customers are, allowing you to accept payments in any channel with a single click."
    },
    {
      image: IMAGES.PAYMENT_LINK_PAYMENT_METHODS,
      title: "All major payment methods",
      header:
        "Payment links support all major payment methods including digital wallets like Apple and Google Pay."
    }
  ],
  [PAGE_BUILDER_ONBOARDING]: [
    {
      image: IMAGES.BLOCKS_PICKER,
      title: "Choose your blocks",
      header:
        "Each page you build is made up of a collection of blocks. You can mix and match blocks for navigation, pricing and more to customize your page."
    }
  ],
  [EDITOR_FIRST_TIME]: [
    {
      image: IMAGES.EDITOR_EDIT_BLOCK,
      title: "Click to customize",
      header:
        "Each block can be customized with your own content. Just click on the block you want to edit to get started."
    },
    {
      image: IMAGES.EDITOR_BLOCK_SETTINGS,
      title: "Drag and drop",
      header:
        "You can reorder your blocks by dragging them up or down. Each block has a settings menu which allows you to control how their content is presented."
    },
    {
      image: IMAGES.EDITOR_SIDE_NAV,
      title: "Page settings",
      header:
        "Use the side nav to see more page builder elements like products, features and settings."
    },
    {
      image: IMAGES.EDITOR_PUBLISH,
      title: "Publish your page",
      header:
        "When you're ready to go live with your page, click publish to make it available to the world!"
    }
  ],
  [PAGE_BUILDER_FEATURE_GROUPS_ONBOARDING]: [
    {
      image: IMAGES.FEATURE_COMPARISON,
      title: "Compare your product features",
      header:
        "Add and group your features per product to help your customers compare their options."
    },
    {
      image: IMAGES.PRODUCT_FEATURE_SHOW,
      title: "Show whats in your products",
      header:
        "Show which features are included in each product by toggling them on and off with a simple click in each cell."
    },
    {
      image: IMAGES.PRODUCT_FEATURE_TOOLTIP,
      title: "Add feature details",
      header:
        "Add an optional tooltip and customize how the product feature is presented by editing it's details."
    }
  ],
  [CAMPAIGN_BUILDER_AUDIENCE_ONBOARDING]: [
    {
      // image: IMAGES.FEATURE_COMPARISON,
      title: "Choose your audience",
      header:
        "Create a new audience by uploading a csv of contacts or use one you've created already"
    }
  ]
};

const FEATURE = {
  USER_ACTIONS: "user_actions",
  LINK_BUILDER: "link_builder",
  PAGE_BUILDER: "page_builder",
  PAGE_BUILDER_FEATURE_GROUPS: "page_builder_feature_groups",
  CAMPAIGN_BUILDER_AUDIENCE: "campaign_builder_audience",
  EDITOR: "editor"
};

const CONTEXT = {
  DASHBOARD_FIRST_TIME: "dashboard_first_time",
  ONBOARDING: "onboarding",
  EDITOR_FIRST_TIME: "editor_first_time"
};

const EDUCATION_CONFIG = {
  [USER_ACTIONS_DASHBOARD_FIRST]: {
    feature: FEATURE.USER_ACTIONS,
    context: CONTEXT.DASHBOARD_FIRST_TIME
  },
  [LINK_BUILDER_ONBOARDING]: {
    feature: FEATURE.LINK_BUILDER,
    context: CONTEXT.ONBOARDING
  },
  [PAGE_BUILDER_ONBOARDING]: {
    feature: FEATURE.PAGE_BUILDER,
    context: CONTEXT.ONBOARDING
  },
  [PAGE_BUILDER_FEATURE_GROUPS_ONBOARDING]: {
    feature: FEATURE.PAGE_BUILDER_FEATURE_GROUPS,
    context: CONTEXT.ONBOARDING
  },
  [CAMPAIGN_BUILDER_AUDIENCE_ONBOARDING]: {
    feature: FEATURE.CAMPAIGN_BUILDER_AUDIENCE,
    context: CONTEXT.ONBOARDING
  },
  [EDITOR_FIRST_TIME]: {
    feature: FEATURE.EDITOR,
    context: CONTEXT.EDITOR_FIRST_TIME
  }
};

export const getEducationSlidesForKey = (key) => EDUCATION_SLIDES[key];

export const getEducationConfigForKey = (key) => EDUCATION_CONFIG[key];
